<template>
<select
  name="city"
  v-validate="modelValidations.additionalData.regularity"
  class="form-control"
  :value="value"
  @change="$emit('change', $event.target.value)"
  @input="$emit('input', $event.target.value)"
>
  <option
    value=""
  >Selecione ...
  </option>
  <option value="paidAccount">Conta paga</option>
  <option value="installmentOfAccount">Parcelamento de conta</option>
  <option value="secondWayAccount">2ª via de conta</option>
  <option value="changeOfTitularity">Troca de titularidade</option>
</select>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'SelectRegularizationMethod',
  props: ['value'],
  computed: {
    ...mapGetters('customers', {modelValidations: 'validations'})
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Customer/SelectRegularizationMethod.vue